// extracted by mini-css-extract-plugin
var _1 = "dialog-button-container__Q83uK";
var _2 = "dialog-content-scrollable__PITlQ";
var _3 = "page__jVuct";
var _4 = "page-content__sDRrv";
var _5 = "page-panel__dNvZT";
export { _1 as "dialogButtonContainer", _2 as "dialogContentScrollable", _3 as "page", _4 as "pageContent", _5 as "pagePanel" }
